import { get, isEmpty } from 'lodash-es';
import React, { useCallback, useEffect, useState } from "react";
import { Nav, NavDropdown, Navbar } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { signOutAgent } from '../../../actions/auth.actions';
import { setBrandStore } from '../../../actions/brand.actions';
//import { initializeCart } from '../../../actions/cart.actions.js';
import { addFlashMessage } from '../../../actions/flashMessages.actions';
import { AGENTS_ENDPOINTS } from '../../../config/api';
import logo from '../../../images/blue_logo.svg';
import christmasLogo from '../../../../assets/images/redesign/new-logo-christmas.png';
import Divider from '../../../shared/components/Divider.jsx';
import LanguageSelector from '../../../shared/components/Header/LanguageSelector.jsx';
import CustomNavDropdown from '../../../shared/components/Nav/NavDropdown';
import '../../../shared/components/Nav/NavDropdown.scss';
import NavLink from '../../../shared/components/Nav/NavLink';
import useBreakpoint from '../../../shared/hooks/useBreakpoint.jsx';
import axios from '../../../utils/axiosConfig';
import './AgentHeader.scss';

const links = [{
  eventKey: "/",
  to: "/",
  text: 'clients.header.campaigns',
}];

export const handleLogout = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  axios.delete(AGENTS_ENDPOINTS.SIGN_OUT)
  .then(() => {
    signOutAgent(dispatch);
    document.location = '/clients/signin';
  }).catch((e) => {
    dispatch(addFlashMessage({
      type: 'error',
      text: t('common.message_error'),
    }));
  });
};


const Header = () => {
  const { t } = useTranslation();
  const agent = useSelector(state => state.auth.agent);
  const simulatedAgent = useSelector(state => get(state, 'config.simulatedAgent'));
  const brand = useSelector(state => get(state, 'brand.brand'));
  const activeBrandId = useSelector(state => get(state, 'brand.brandId') || get(state, 'brand.account.id'));
  const loadingBrand = useSelector(state => get(state, 'brand.loading'));
  //const cart = useSelector(store => get(store, 'cart'));
  const brands = get(simulatedAgent, 'brands') || get(agent, 'brands');
  const location = useLocation();
  const breakpoint = useBreakpoint();

  const dispatch = useDispatch();

  const [state, setState] = useState({
    loading: false,
    defaultPath: '/',
    brandId: activeBrandId,
    currentLogo: logo
  });
  const history = useHistory();

  useEffect(() => {
    if (false && agent) {
      axios.get(AGENTS_ENDPOINTS.CART.GET).then((response) => {
        const orderItems = get(response, 'data.cart.order_items');
        const forPurchaseUserPosts = orderItems ? orderItems.map((item) => (item.user_post)) : [];
        dispatch(initializeCart(forPurchaseUserPosts));
      });
    }

    /*
    const nexExpBannerHidden = sessionStorage.getItem('nexExpBannerHidden');
    if (agent && !nexExpBannerHidden && agent.disable_new_experience == false) {
      dispatch(addFlashMessage({
        id: 'switch-exp-banner',
        type: 'success',
        text: <Fragment>
          Welcome to the new Obviously Dashboard. If you prefer to use the old experience, please&nbsp;
          <a href="/clients/switch_experience" className="text-2">click here</a>.<br />
          If you want to save your preference and hide this banner forever, please click <a href="/clients/switch_experience/?dont_ask_again=true" className="text-2">
            don't ask me again.
          </a>.
        </Fragment>,
        onClose: () => {
          sessionStorage.setItem('nexExpBannerHidden', true);
        }
      }));
    } else {
      dispatch(deleteFlashMessage('switch-exp-banner'));
    }
    */
  }, [agent]);

  useEffect(() => {
    axios.get(`/api/v1/feature_flags/${encodeURIComponent('Christmas Logo')}`)
    .then(({ data }) => {
      setState({
        ...state,
        currentLogo: data.enabled ? christmasLogo : logo,
        loading: false,
      });
    }).catch(_ => setState({
      ...state,
      loading: false,
    }));
  }, [agent]);


  useEffect(() => {
    const defaultPath = `/${location.pathname.split('/')[1]}`;
    setState({
      ...state,
      defaultPath
    });
  }, [location.pathname]);

  useEffect(() => {
    setState({
      ...state,
      brandId: activeBrandId
    });
  }, [activeBrandId]);

  const renderBrandsDropdown = useCallback(() => {
    if (!brands) return null;

    return brands
      .sort((a, b) => a.name.localeCompare(b.name))
      .map(b =>
        <NavDropdown.Item key={b.id}
          onClick={() => {
            dispatch(setBrandStore({
              brandId: b.id
            }));
          }}
          to="/"
          active={b.id === +activeBrandId}
          as={Link}
        >
          {b.name}
        </NavDropdown.Item>
      );
  }, [dispatch, setBrandStore, activeBrandId]);

  const renderNav = useCallback(() =>
    <Nav activeKey={state.defaultPath}>
      {
        brands.length > 1 &&
        <CustomNavDropdown
          id="dropdown-agent-brands"
          className="custom-nav-dropdown"
          title={get(brand, 'account.name')}
          alignRight={breakpoint !== 'xs'}
          disabled={loadingBrand}>
          {renderBrandsDropdown()}
        </CustomNavDropdown>
      }

      {links.map(link => <NavLink
        key={link.eventKey}
        eventKey={link.eventKey}
        active={link.eventKey === location.pathname}
        as={Link}
        to={link.to}
        badge={link.badge}
        icon={link.icon}
        text={t(link.text)}
      />)}

      <CustomNavDropdown
        id="dropdown-agent-content"
        className="custom-nav-dropdown"
        title={t('clients.header.content')}
        active={["/accounts/user_posts", "purchased-content"].includes(location.pathname)}
        alignRight={breakpoint !== 'xs'}>
        <NavDropdown.Item
          to="/accounts/user_posts"
          active={location.pathname === "/accounts/user_posts"}
          as={Link}
        >
          {t('clients.header.all_posts')}
        </NavDropdown.Item>
        {
          get(brand, 'account.purchased_media_rights.length') > 0 &&
          <NavDropdown.Item
            to="/purchased-content"
            active={location.pathname === "/purchased-content"}
            as={Link}
          >
            {t('clients.header.purchased_content')}
          </NavDropdown.Item>
        }
        { get(brand, 'account.content_cloud_length', 0) > 0 &&
          <NavDropdown.Item
            to="/content-cloud"
            active={location.pathname === "/content-cloud"}
            as={Link}
          >
            {t('clients.header.content_cloud')}
          </NavDropdown.Item>
        }
      </CustomNavDropdown>

      {
        get(brand, 'influencers_count') > 0 &&
        <NavLink
          eventKey="/creators"
          as={Link}
          to="/creators"
          active={location.pathname === "/creators"}
          text={t("clients.header.creators", { amount: get(brand, 'influencers_count', 0) })}
        />
      }

      { /*

              <NavLink
                eventKey="/reporting-offer-groups"
                as={Link}
                to="/reporting-offer-groups"
                text={t("clients.header.reporting")}
              />

              */ }

      {
        !(isEmpty(get(brand, 'account.image_looker_reports')) && isEmpty(get(brand, 'account.link_looker_reports'))) &&
        <NavLink
          eventKey="/reports"
          as={Link}
          to="/reports"
          active={location.pathname === "/reports"}
          text={t("clients.header.reports")}
        />
      }

      <LanguageSelector activeLanguages={['en', 'fr', 'es']} mobile={breakpoint === 'xs'} />

      <CustomNavDropdown
        id="navdropdown-settings"
        className={`custom-nav-dropdown ${breakpoint !== 'xs' ? 'icon-only' : ''}`}
        title={
          breakpoint === 'xs' ?
            t('common.header.settings') :
            <i className="fal fa-cog" />
        }
        alignRight={breakpoint !== 'xs'}>
        <NavDropdown.Item to={AGENTS_ENDPOINTS.PROFILE.EDIT} as={Link}>
          {t('clients.header.settings')}
        </NavDropdown.Item>
        <NavDropdown.Item to="/invoices" as={Link}>
          {t('clients.header.invoices')}
        </NavDropdown.Item>
        {breakpoint !== 'xs' &&
          <NavDropdown.Item
            onClick={handleLogout}>
            {t('clients.header.sign_out')}
          </NavDropdown.Item>
        }
      </CustomNavDropdown>

      {false && cart.order.length ? <NavLink
        eventKey={"/cart"}
        as={Link}
        to={"/cart"}
        badge={cart.order.length}
        icon={<i className="fal fa-shopping-cart" />}
      /> : null}

      {breakpoint === 'xs' &&
        <NavLink onClick={handleLogout} text={t('clients.header.sign_out')} />
      }

    </Nav>
  );

  const renderDesktopNavbar = () => {
    if (agent && !state.isLoading) {
      return <React.Fragment>
        <Nav className="nav-no-collapsible" />
        {renderNav()}
        <Divider />
      </React.Fragment>;
    }
    return null;
  };
  const renderMobileNavbar = () => {
    if (agent && !state.loading) {
      return <React.Fragment>
        <Navbar.Collapse id="navbarHeaderMobile">
          {renderNav()}
          <Divider className="m-0" />
        </Navbar.Collapse>
        <Divider />
      </React.Fragment>;
    }
    // No auth header
    return null;
  };

  const handleLogout = useCallback(() => {
    axios.delete(AGENTS_ENDPOINTS.SIGN_OUT)
      .then(() => {
        signOutAgent(dispatch);
        document.location = '/clients/signin';
      }).catch((e) => {
        dispatch(addFlashMessage({
          type: 'error',
          text: t('common.message_error'),
        }));
      });
  }, [history, signOutAgent]);

  if(!agent && !state.loading) {
    return null;
  }

  return (
    <header className="header">
      <Navbar collapseOnSelect
        expand="sm" fixed="top" bg="light">
        <div className='navbar-wrapper'>
          <Navbar.Brand to="/" as={Link}>
            <img className="header-logo" src={state.currentLogo} alt="Obviously logo" />
          </Navbar.Brand>

          {breakpoint === 'xs'
            ? <Nav className="nav-no-collapsible"
              activeKey={state.defaultPath}>

              <Navbar.Toggle aria-controls="navbarHeaderMobile">
                <span>
                  <i className="fal fa-bars" />
                </span>
              </Navbar.Toggle>
            </Nav>
            : null}

          {breakpoint !== 'xs' && renderDesktopNavbar()}
        </div>
        {breakpoint === 'xs' && renderMobileNavbar()}

      </Navbar>
    </header >
  );
};

export default React.memo(Header);
